import React, { useRef, useState } from 'react';
import { MdOutlineModeEditOutline } from 'react-icons/md';
import { FormOption } from 'types';
import { Button, ModalContent } from 'components';
import { EmployeeContent } from './components';

interface Props {
  employeeList: FormOption[];
  setEmployeeList: React.Dispatch<React.SetStateAction<FormOption[]>>;
}

export function EmployeeManager({ employeeList, setEmployeeList }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  function handleOpen() {
    setIsOpen(true);
  }

  function handleClose() {
    setIsOpen(false);
  }

  return (
    <>
      <Button variant="outline-secondary" type="button" onClick={handleOpen}>
        {Boolean(employeeList.length) ? 'Gerenciar' : 'Cadastrar'} vendedores{' '}
        <MdOutlineModeEditOutline size={18} />
      </Button>
      {isOpen && (
        <ModalContent ref={closeButtonRef} handleClose={handleClose}>
          <EmployeeContent
            employeeList={employeeList}
            setEmployeeList={setEmployeeList}
            handleClose={handleClose}
          />
        </ModalContent>
      )}
    </>
  );
}
